<template>
  <layout :title="job.title">
    <div class="max-w-4xl px-5 mx-auto lg:px-0 pb-12 mt-10">
      <a
        href="https://app.sesametime.com/jobs/youverse"
        class="inline-flex items-center mb-6 font-mono text-sm font-bold cursor-pointer text-primary-color"
      >
        <svg
          class="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          ></path>
        </svg>
        back to careers
      </a>
      <h1 class="flex flex-col leading-none">
        <span class="break-words text-3xl font-extrabold">{{ job.title }}</span>
        <span class="mt-2 text-gray-600" v-if="job.created_at"
          >Created at {{ job.created_at | formatDate }}</span
        >
      </h1>
      <div class="md:flex flex-row items-start mt-10 md:space-x-6">
        <div
          class="prose prose-lg lg:prose-xl p-4 bg-white shadow-allArround rounded-xl md:w-3/4"
          v-html="job.body"
        >
          {{ job.body }}
        </div>
        <div
          class="flex-1 p-4 bg-white shadow-allArround rounded-xl space-y-2 md:mt-0 mt-5 sticky top-20"
        >
          <div class="flex flex-col">
            <span>Job position</span>
            <span class="text-gray-600 text-sm">{{ job.category }}</span>
          </div>
          <div class="flex flex-col">
            <span>Contract type</span>
            <span class="text-gray-600 text-sm">{{ job.contract_type }}</span>
          </div>
          <div class="flex flex-col">
            <span>Location</span>
            <span class="text-gray-600 text-sm">{{ job.location }}</span>
          </div>
          <div
            class="flex flex-col"
            v-if="this.$page.props.job.experience != null"
          >
            <span>Experience</span>
            <span class="text-gray-600 text-sm">{{ job.experience }}</span>
          </div>
          <div
            class="flex flex-col"
            v-if="this.$page.props.job.open_until != null"
          >
            <span>Open until</span>
            <span class="text-gray-600 text-sm">{{
              job.open_until | formatDate
            }}</span>
          </div>
          <div class="pt-2">
            <button
              v-if="canApply"
              class="btn-primary w-full"
              @click="showFormApply = true"
            >
              Apply
            </button>
            <button
              v-else
              class="btn-no-color w-full bg-gray-200 text-gray-700"
              style="cursor: unset"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
    <modalForm :show="showFormApply" @closeModal="showFormApply = false">
      <form
        role="form"
        @submit.prevent="submitApply"
        method="POST"
        enctype="multipart/form-data"
      >
        <div>
          <label
            for="email"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Email address</label
          >
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="email"
              type="email"
              name="email"
              v-model="form.email"
              required
              class="w-full"
              autofocus
            />
          </div>

          <div class="error" v-if="errors.email">{{ errors.email }}</div>
        </div>

        <div class="mt-6">
          <label
            for="message"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Message
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <textarea
              id="message"
              type="text"
              name="message"
              v-model="form.message"
              required
              class="w-full"
              rows="2"
            />
          </div>
          <div class="error" v-if="errors.message">
            {{ errors.message }}
          </div>
        </div>

        <div class="mt-6">
          <label
            for="cv"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            CV in PDF
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="cv"
              type="file"
              name="message"
              accept="application/pdf"
              @change="assignCvFile"
              required
              class="w-full"
            />
          </div>
          <div class="error" v-if="errors.cv">
            {{ errors.cv }}
          </div>
        </div>

        <div class="mt-6">
          <span class="block w-full rounded-md shadow-sm">
            <button type="submit" class="btn-primary w-full">Apply</button>
          </span>
        </div>
      </form>
    </modalForm>
    {{ errors.email }}
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
import { LocationMarkerIcon, BriefcaseIcon } from "@vue-hero-icons/outline";
import modalForm from "../Components/modal.vue";
export default {
  props: {
    errors: Object,
  },
  components: { layout, LocationMarkerIcon, BriefcaseIcon, modalForm },
  data() {
    return {
      job: this.$page.props.job,
      showFormApply: false,
      form: {
        email: null,
        message: null,
        cv: null,
        jobName: this.$page.props.job.title,
      },
      canApply:
        this.$page.props.job.open_until == null
          ? true
          : new Date().getDate() <=
            new Date(this.$page.props.job.open_until).getDate(),
    };
  },
  methods: {
    submitApply() {
      this.$inertia.post("/apply-job", this.form, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null)
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
            });
          this.showFormApply = false;
          this.form.email = null;
          this.form.message = null;
          this.form.cv = null;
        },
      });
    },
    assignCvFile(event) {
      this.form.cv = event.target.files[0];
    },
  },
};
</script>